import React from 'react';
import { Icon } from './icon';

const Modal = ({
  open,
  handleClose,
  children,
  className,
  notCrossIcon,
  style,
  childrenClass,
  enableClickOutsideClose = true,
  isBackButton = false,
}) => {
  return (
    <>
      {open && (
        <div
          className="t-w-screen t-h-screen t-z-[9999] t-left-0 t-top-0 t-fixed t-shadow t-bg-background t-flex t-justify-center t-items-center t-overflow-x-hidden t-overflow-y-auto m-0 t-p-2 sm:t-p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.7)', margin: '0px' }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            if (enableClickOutsideClose) setTimeout(() => handleClose(), 0);
          }}
        >
          <div
            className={`t-relative t-bg-white t-text-black t-rounded-[0.5rem] t-px-4 t-xl:px-6 t-2xl:px-12 t-border-[1px] t-border-white  ${className}`}
            style={style}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            {notCrossIcon ? null : isBackButton ? (
              <button
                className="t-sticky t-top-0 !t-w-full  t-flex t-items-center t-justify-start t-bg-white t-py-2 t-z-10"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleClose();
                }}
              >
                <Icon name="chevronLeft" size={24} />
                <p className="!t-m-0 !t-text-lg">Back</p>
              </button>
            ) : (
              <div className="t-sticky t-top-0 t-flex t-items-end t-justify-end t-bg-white t-py-2 t-pr-2 sm:t-pr-4 t-z-10 t-rounded-[0.5rem_0.5rem_0_0]">
                <Icon
                  name="cross"
                  size={24}
                  className="t-self-end t-fill-black t-bg-white t-font-bold t-rounded-full t-cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleClose();
                  }}
                />
              </div>
            )}

            <div
              className={`t-flex t-flex-col t-items-center t-justify-center t-w-full t-gap-4 ${childrenClass}`}
            >
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { Modal };
